import { HomeSVGIcon } from '../assets/HomeSVGIcon'
import { SearchSVGIcon } from '../assets/SearchSVGIcon'
import { CalendarSVGIcon } from '../assets/CalendarSVGIcon'
import { NATIVE_APP_HELPER } from 'constants/native_app_helper.constants'

import { type GetRoutesPropsType, type UrlGeneratorPropsType } from '../types'

const pathGenerator = (props: UrlGeneratorPropsType) => {
  const {
    subdomains: { parrentSubDomain, childSubDomain },

    link
  } = props

  if (NATIVE_APP_HELPER.SOLID_SPORT_APP.IS_CURRENT_DOMAIN) {
    if (link === 'search') {
      return childSubDomain ? `/${childSubDomain}/${link}` : `/${link}`
    }
    return `/${link}`
  }
  if (link === 'search') {
    return childSubDomain
      ? `/${childSubDomain}/${link}`
      : parrentSubDomain
      ? `/${parrentSubDomain}/${link}`
      : `/${link}`
  }
  return parrentSubDomain ? `/${parrentSubDomain}/${link}` : `/${link}`
}

const generateSolidSportRoutes = (
  subdomains: {
    parrentSubDomain?: string
    childSubDomain?: string
  },
  isError: boolean
) => {
  return [
    {
      name: 'Calendar',
      path: pathGenerator({
        subdomains,
        isError,
        link: 'calendar'
      }),
      icon: CalendarSVGIcon
    },
    {
      name: 'Search',
      path: pathGenerator({
        subdomains,
        isError,
        link: 'search'
      }),
      icon: SearchSVGIcon
    }
  ]
}

const generateDefaultRoutes = (
  subdomains: {
    parrentSubDomain?: string
    childSubDomain?: string
  },
  isError: boolean
) => {
  return [
    {
      name: 'Home',
      path: pathGenerator({
        subdomains,
        isError,
        link: 'feed'
      }),
      icon: HomeSVGIcon
    },
    // {
    //   name: 'Feed',
    //   path: pathGenerator({
    //     subdomains,
    //     isError,
    //     link: 'feed'
    //   }),
    //   icon: HomeSVGIcon
    // },
    {
      name: 'Calendar',
      path: pathGenerator({
        subdomains,
        isError,
        link: 'calendar'
      }),
      icon: CalendarSVGIcon
    },
    {
      name: 'Search',
      path: pathGenerator({
        subdomains,
        isError,
        link: 'search'
      }),
      icon: SearchSVGIcon
    }
  ]
}

export const getRoutes = (props: GetRoutesPropsType) => {
  const { subdomains, isError } = props
  if (NATIVE_APP_HELPER.SOLID_SPORT_APP.IS_CURRENT_DOMAIN) {
    return generateSolidSportRoutes(subdomains, isError)
  }
  return generateDefaultRoutes(subdomains, isError)
}
